import React, {
    useCallback, useState, useEffect
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { MetadataForm } from '@jutro/uiconfig';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withApplicationPropertyContext, PaymentComponent } from 'tdic-components-platform-react';
import metadata from './ChangeAutopayBankAccount.metadata.json5';
import messages from './ChangeAutopayBankAccount.messages';

function ChangeAutopayBankAccount({
    callbackCancelChangeBankAccount, bankAccountPaymentInstrument,
    callbackConfirmChangeBankAccount, model, prevPaymentInstrumentPlan, cancellationStatus
}) {
    const [isTnCAccepted, updateTnCAccepted] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(prevPaymentInstrumentPlan);

    useEffect(() => {
        setSelectedPaymentMethod(prevPaymentInstrumentPlan);
    }, [prevPaymentInstrumentPlan]);

    const onRadioButtonChange = useCallback((value) => {
        const paymentDataClone = _.cloneDeep(selectedPaymentMethod);
        _.set(paymentDataClone, 'paymentPlan', value);
        setSelectedPaymentMethod(paymentDataClone);
        updateTnCAccepted(false);
    }, [selectedPaymentMethod, setSelectedPaymentMethod, updateTnCAccepted]);

    const overrideProps = {
        changeBankAccountComponentId: {
            xCenter: 'bc',
            model,
            nextLabel: messages.setupAutomaticPayments,
            bankAccountPaymentInstrument,
            updateTnCAccepted: updateTnCAccepted,
            isTnCAccepted,
            title: messages.changePaymentMethod,
        },
    };
    const readValue = (id, path) => {
        return readViewModelValue(metadata.componentContent, {}, id, path, overrideProps);
    };

    const resolvers = {
        resolveComponentMap: {
            paymentpagecomponent: PaymentComponent
        },
        resolveCallbackMap: {
            onClickConfirmChangeBankAccount: callbackConfirmChangeBankAccount,
            onClickCancelChangeBankAccount: callbackCancelChangeBankAccount,
            onRadioButtonChange
        },
        selectPaymentPlan: {
            visible: cancellationStatus !== 'canceled'
        }
    };

    return (
        <MetadataForm
            data={{}}
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            resolveValue={readValue}
        />
    );
}

ChangeAutopayBankAccount.propTypes = {
    callbackConfirmChangeBankAccount: PropTypes.func.isRequired,
    callbackCancelChangeBankAccount: PropTypes.func.isRequired,
    model: PropTypes.shape({}).isRequired,
    prevPaymentInstrumentPlan: PropTypes.shape({
        paymentPlan: PropTypes.string,
    }).isRequired,
    cancellationStatus: PropTypes.string.isRequired,
    bankAccountPaymentInstrument: PropTypes.shape({}).isRequired
};

export default
withRouter(withAuthenticationContext(withApplicationPropertyContext(ChangeAutopayBankAccount)));
